module.exports = __webpack_public_path__ + "media/js/components/main/Second/images/notBook-ff4bf38b91b2512d7a9b33d46731002e.png";